import { Col, Form, Row, Stack } from "react-bootstrap";
import { Container } from "react-bootstrap";
import { EnhancedButton } from "../components/buttons/EnhancedButton";
import FableousLogoTitle from "../components/graphic/FableousLogoTitle";
import HeroBanner from "../components/layout/HeroBanner";
import { useAnimateText } from "../hooks/useAnimateText";
import { navigate } from "vike/client/router";
import ResponsiveImage from "../components/layout/ResponsiveImage";
import MktgCover2 from "../assets/images/MktgCover2.png";
import MktgCover4 from "../assets/images/MktgCover4.png";
import MktgInside1Lg from "../assets/images/MktgInside1Lg.png";

export default function HomeLander() {
	const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		const target = event.target as typeof event.target & {
			topic: { value: string };
		};
		const params = new URLSearchParams({topic: target.topic.value});
		void navigate(`/stories/create?${params.toString()}`);
	};

	const { value } = useAnimateText([
		"A little boy called James who wants to fly an airplane",
		"A baby girl called Emily who is trying to say her first words",
		"A little girl called Olivia who wants to fly a dragon to a strange land",
	]);

	return (
		<>
			<HeroBanner containerClassName="text-white px-5 py-5">
				<Container fluid={"md"}>
					<Row>
						<Col sm={12} className="p-2 mb-3">
							<FableousLogoTitle maxHeight={200} />
						</Col>
					</Row>
					<Row>
						<Col sm={12} className="mb-4">
							<h1 className="display-5 fw-bold text-primary">Give the gift of unique stories</h1>
							<p className="lead">
								Create illustrated stories featuring your loved ones in 20 minutes or less, with the power of AI. Get a lifetime of memories from high
								quality, fully illustrated, printed books.
							</p>
						</Col>
					</Row>
					<Row>
						<Form onSubmit={onSubmit}>
							<Stack gap={3}>
								<Form.Group as={Row} controlId="topic">
									<Col lg={10} sm={9} className="mb-2">
										<Form.Control name="topic" placeholder={value} />
									</Col>
									<Col lg={2} sm={3}>
										<EnhancedButton type="submit" block>
											Get started
										</EnhancedButton>
									</Col>
								</Form.Group>
							</Stack>
						</Form>
					</Row>
				</Container>
			</HeroBanner>
			<HeroBanner containerClassName="bg-white py-3">
				<Row>
					<Col sm={8}>
						<ResponsiveImage
							originalHeight={300}
							originalWidth={450}
							url={MktgCover2}
							alt="An example cover of a Fableous customised book set in a child's bedroom with toys."
							loading="eager"
							fetchPriority="high"
						/>
					</Col>
					<Col sm={4} className="d-flex flex-column justify-content-center text-start p-3">
						<h3 className="fw-bold mb-3">Turn your child into the hero</h3>
						<p className="mb-4">
							Create magical storybooks personalised with your child’s name, adventures, and imagination.
						</p>
						<div className="d-flex gap-3">
							<EnhancedButton href="/stories/create?topic=" variant="primary" size="lg">
								Start your story
							</EnhancedButton>
						</div>
					</Col>
				</Row>
			</HeroBanner>
			<HeroBanner containerClassName="bg-secondary py-3">
                <Row>
					<Col sm={6} className="d-flex flex-column justify-content-center text-start p-3">
						<h3 className="fw-bold mb-3">Unique stories from a simple idea</h3>
						<p className="mb-4">
							From an easy starting point, we'll help you create a gift that will be treasured for years. Rich stories, enchanting artwork and your own personal touch.
						</p>
						<div className="d-flex gap-3">
							<EnhancedButton href="/how-it-works" variant="primary" size="lg">
								See how it works
							</EnhancedButton>
						</div>
					</Col>
                    <Col sm={6} >
						<ResponsiveImage
							originalHeight={400}
							originalWidth={400}
                            maxHeight={400}
							url={MktgCover4}
							alt="An example Fableous customised book held by a curious child."
							loading="eager"
							fetchPriority="high"
						/>
					</Col>
                </Row>
            </HeroBanner>
			<HeroBanner containerClassName="bg-white py-3">
                <Row>
                    <Col sm={4} >
						<ResponsiveImage
							originalHeight={400}
							originalWidth={267}
                            maxHeight={400}
							url={MktgInside1Lg}
							alt="An example inside page of a Fableous customised book set on a cosy dinner table."
							loading="eager"
							fetchPriority="high"
						/>
					</Col>
					<Col sm={8} className="d-flex flex-column justify-content-center text-start p-3">
						<h3 className="fw-bold mb-3">Unbelievable artwork</h3>
						<p className="mb-4">
							Select from different illustration styles and see your story magically come to life.
						</p>
						<div className="d-flex gap-3">
							<EnhancedButton href="/art-styles" variant="primary" size="lg">
								See example artwork
							</EnhancedButton>
						</div>
					</Col>
                </Row>
            </HeroBanner>
		</>
	);
}
